var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnBoardMeals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 8,
    d: "M98 35C102.418278 35 106 38.581722 106 43L106 87C106 91.418278 102.418278 95 98 95L90 95 90 65 60 65 60 95 22 95C17.581722 95 14 91.418278 14 87L14 43C14 38.581722 17.581722 35 22 35L98 35zM54.5 25L66.5 25C68.709139 25 70.5 26.790861 70.5 29L70.5 35 70.5 35 50.5 35 50.5 29C50.5 26.790861 52.290861 25 54.5 25z"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "currentColor",
    strokeWidth: 8,
    points: "75 65 80 50 85 50"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 40,
    x: 60,
    y: 65,
    stroke: "currentColor",
    strokeWidth: 8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnBoardMeals);
export default __webpack_public_path__ + "static/media/on-board-meals.9487262c6302d558011f4cb718dfbf5a.svg";
export { ForwardRef as ReactComponent };